var map = {
	"./call-911.svg": 16723,
	"./checkmark.svg": 85682,
	"./close-door.svg": 72823,
	"./crossmark.svg": 32937,
	"./crouch.svg": 29992,
	"./elevator.svg": 15134,
	"./icon_a.svg": 58521,
	"./icon_arrow_bottom_left.svg": 36846,
	"./icon_b.svg": 3997,
	"./icon_bubble.svg": 94006,
	"./icon_check.svg": 96204,
	"./icon_info.svg": 62519,
	"./icon_x.svg": 56055,
	"./icon_y.svg": 85275,
	"./logo-ad-concil.svg": 52986,
	"./logo-brand.svg": 45934,
	"./logo-fema.svg": 94644,
	"./logo-ready.svg": 76173,
	"./move-away.svg": 13296,
	"./open-door.svg": 11753,
	"./open-window.svg": 37985,
	"./packing-stuff.svg": 26593,
	"./pause.svg": 71359,
	"./play.svg": 78212,
	"./sound.svg": 10648,
	"./take-stairs.svg": 28738,
	"./wet-towel.svg": 65962
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80376;